var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", "max-width": "320" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(
              " " + _vm._s(_vm.$t("hourOverview.buttons.printoutDetail")) + " "
            )
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "hours/printtimesheet",
                      Object.assign({}, _vm.printParameters, {
                        detail: 1,
                        breakRoom: 1
                      })
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Mit Pausenraum ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "hours/printtimesheet",
                      Object.assign({}, _vm.printParameters, {
                        detail: 1,
                        breakRoom: 0
                      })
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Ohne Pausenraum ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "hours/printtimesheet",
                      Object.assign({}, _vm.printParameters, {
                        "department-sum": 1
                      })
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Bereichssummen ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "corrispettivi",
                      Object.assign({}, _vm.printParameters)
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Corrispettivi ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "vacations/print",
                      Object.assign({}, _vm.printParameters)
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Abwesenheiten / Urlaube ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }